import { Cookies } from 'react-cookie';
import { COOKIES, DefaultCookieOptions } from '../../constants/misc.js';

function removeAuthToken() {
    const cookies = new Cookies();
    cookies.remove(COOKIES.token, DefaultCookieOptions);
    cookies.remove(COOKIES.companyId, DefaultCookieOptions);
    cookies.remove(COOKIES.newUser, DefaultCookieOptions);
}

export { removeAuthToken };
//# sourceMappingURL=removeAuthToken.js.map
